/* Material */
export const GET_PREPARE_AREAS= "GET_PREPARE_AREAS"
export const GET_PREPARE_AREAS_SUCCESS = "GET_PREPARE_AREAS_SUCCESS"
export const GET_PREPARE_AREAS_FAIL = "GET_PREPARE_AREAS_FAIL"

export const POST_PREPARE_AREA= "POST_PREPARE_AREA"
export const POST_PREPARE_AREA_SUCCESS = "POST_PREPARE_AREA_SUCCESS"
export const POST_PREPARE_AREA_FAIL = "POST_PREPARE_AREA_FAIL"